import url from "./sprinter-15-floorplan.webp";
export default { url };
